import React from 'react'
import "./CommomBanner.css"
import { END_URL, IMG_URL } from "../../config";

function CommomBanner({banner,name}) {
  return (
    <div className='row common-banner-row'>
<div className="common-img">

    <img src={`${IMG_URL}/d0/${banner}`} alt="" />

    <div className="text-div">

        <h1>{name}</h1>

    </div>

</div>

    </div>
  )
}

export default CommomBanner